<template>
    <div class="site-footer">
        <!-- <span class="social-label">{{$T('follows Unitel')}}</span>
        <ul class="social-list">
            <li class="social-list-item">
                <a :href="social.twitter" title="twitter" target="_blank">
                    <i class="fab fa-twitter"></i>
                </a>
            </li>
            <li class="social-list-item">
                <a :href="social.linkedin" title="linkedin" target="_blank">
                    <i class="fab fa-linkedin-in"></i>
                </a>
            </li>
            <li class="social-list-item">
                <a :href="social.facebook" title="facebook" target="_blank">
                    <i class="fab fa-facebook-f"></i>
                </a>
            </li>
            <li class="social-list-item">
                <a :href="social.instagram" title="instagram" target="_blank">
                    <i class="fab fa-instagram"></i>
                </a>
            </li>
        </ul> -->
        <div class="site-info">© {{ currentYear }} - Todos os direitos reservados.</div>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: "VSocial",
        data() {
            return {
                social: {
                    'facebook': 'https://www.facebook.com/unitel.ao',
                    'instagram': 'https://www.instagram.com/unitelangola/',
                    'linkedin': 'https://www.linkedin.com/company/unitel/',
                    'twitter': 'https://twitter.com/unitel_angola'
                },
                currentYear: new Date().getFullYear()
            }
        },
        mounted() {
            //this.getSocial();
        },
        methods: {
            getSocial(){
                axios.get(`${config.appUrl}/api/social/tips`).then(({data}) => {
                    this.social = data;
                })
            },
        }
    }
</script>

<style scoped lang="stylus">
    .site-footer
        display flex
        flex-direction column
        align-items center
        color $primary
        margin 0 0 40px 0
        position absolute
        width 100%
        padding-bottom 80px

    .social-label
        display block
        margin-bottom 8px

    .site-info
        text-align center
        font-size 14px
        padding 0 32px 20px 32px

    .social-list
        margin 16px 0
        padding 0
        list-style none
        display flex
        width 100%
        align-items center
        justify-content center

    .social-list-item
        padding 0
        width 32px
        height 32px
        margin 0 4px

        a
            display flex
            width 100%
            height 100%
            align-items center
            justify-content center
            color #5E0A8B //$secondary

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Social.vue